import { USER_LOGOUT } from '../actions/userActions';

import {
  STRIPE_CUSTOMER_LOADING,
  STRIPE_CUSTOMER_SUCCESS,
  STRIPE_CUSTOMER_ERROR
} from '../actions/stripeCustomerActions';

const INITIAL_STATE = {};

export default function stripeReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case STRIPE_CUSTOMER_LOADING:
      return {
        ...state,
        status: 'loading',
        error: null
      };

    case STRIPE_CUSTOMER_SUCCESS:
      if (process.env.NODE_ENV !== 'production') {
        console.log('STRIPE_CUSTOMER_SUCCESS action', action);
      }

      return action.payload;

    case STRIPE_CUSTOMER_ERROR:
      if (process.env.NODE_ENV !== 'production') {
        console.log('STRIPE_CUSTOMER_ERROR action', action);
      }

      const { status, statusText } = action.payload.response;
      const { message } = action.payload;

      return {
        ...state,
        error: {
          status,
          statusText,
          message
        },
        status: 'error'
      };

    case USER_LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/stripeCustomersReducer.js